"use strict";

// const ac = require('ve-api-check');
var cutSequenceByRestrictionEnzyme = require("./cutSequenceByRestrictionEnzyme");

module.exports = function getCutsitesFromSequence(sequence, circular, restrictionEnzymes) {
  //validate args!
  // ac.throw([
  //     ac.string,
  //     ac.bool,
  //     ac.array
  // ], arguments);

  var cutsitesByName = {};
  // const allCutsite= [];
  for (var i = 0; i < restrictionEnzymes.length; i++) {
    var re = restrictionEnzymes[i];
    var cutsites = cutSequenceByRestrictionEnzyme(sequence, circular, re);
    if (cutsites.length) {
      cutsitesByName[re.name] = cutsites;
    }
  }
  return cutsitesByName;
};